import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface FeatureState {
  view_Case: boolean;
  allowedFeatures: Set<string>;
  currentUserRoleApp: string;
}

const initialState: FeatureState = {
  view_Case: false,
  allowedFeatures: new Set(),
  currentUserRoleApp: "",
};

const FeatureAccessSlice = createSlice({
  name: "feature_access",
  initialState,
  reducers: {
    setView_Case: (state, action: PayloadAction<boolean>) => {
      state.view_Case = action.payload;
    },
    setAllowedFeature: (state, action: PayloadAction<Set<string>>) => {
      state.allowedFeatures = action.payload;
    },
    setCurrentUserRoleApp: (state, action: PayloadAction<string>) => {
      state.currentUserRoleApp = action.payload;
    },
  },
});

export const { setView_Case, setAllowedFeature, setCurrentUserRoleApp } = FeatureAccessSlice.actions;
export default FeatureAccessSlice.reducer;
